module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAB9BAMAAAD5BFR9AAAAGFBMVEVMaXFARWA/Q1w9QVw/QVw+QFw+QFs9QFsSsrpWAAAAB3RSTlMAMEV1irrPZL9tJwAAAFhJREFUeNrt1jEVgDAAQ8FawAIWagELWMAC9pnLliFL352AP+ZlDFZvjbS0dJYGACBx13iq0tJZ+qyxdADAjmaNpyotnaWvGksHAOzoqPFUpaWz9FNj6X4+mvKJy52TpyUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/burger.png
// module id = 294
// module chunks = 0